import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PricingService } from '@api/services/pricing.service';
import * as PricingActions from '../actions/pricing.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class PricingEffects {
  loadPricingPlans$;

  constructor(
    private actions$: Actions,
    private pricingService: PricingService
  ) {
    this.loadPricingPlans$ = createEffect(() =>
      this.actions$.pipe(
        ofType(PricingActions.loadPricingPlans),
        switchMap(() =>
          this.pricingService.pricingGetPricingPlans({}).pipe(
            map(response => PricingActions.loadPricingPlansSuccess({ 
              pricingInfo: response.pricingInfo || {} 
            })),
            catchError(error =>
              of(PricingActions.loadPricingPlansFailure({ 
                error: error?.message || 'Failed to load pricing plans' 
              }))
            )
          )
        )
      )
    );
  }
}
